<template>
  <div v-if="moderator" class="page page-moderation">
    <div class="page-moderation-header">
      <ui-button
        color="red"
        size="large"
        class="logoutButton"
        @click="logoutAction"
        >Выход
      </ui-button>
      <ui-tabs>
        <ui-tab
          id="new"
          @select="changeTab"
          :title="`Новые ${moderator.stats ? `(${moderator.stats.new})` : ''}`"
        ></ui-tab>
        <ui-tab
          id="changed"
          @select="changeTab"
          :title="
            `Измененные ${
              moderator.stats ? `(${moderator.stats.changed})` : ''
            }`
          "
        ></ui-tab>
        <ui-tab
          id="accepted"
          @select="changeTab"
          :title="
            `Принятые ${moderator.stats ? `(${moderator.stats.accepted})` : ''}`
          "
        ></ui-tab>
        <ui-tab
          id="declined"
          @select="changeTab"
          :title="
            `Отклоненные ${
              moderator.stats ? `(${moderator.stats.declined})` : ''
            }`
          "
        ></ui-tab>
        <ui-tab
          id="blocked"
          @select="changeTab"
          :title="
            `Заблокированные ${
              moderator.stats ? `(${moderator.stats.blocked})` : ''
            }`
          "
        ></ui-tab>
        <ui-tab
          id="all"
          @select="changeTab"
          :title="
            `Все страницы ${moderator.stats ? `(${moderator.stats.all})` : ''}`
          "
        ></ui-tab>
      </ui-tabs>
      <ui-button
        @click="$router.push('/moderation/super')"
        v-if="$store.state.moderator.super_moder"
        >Административная панель модераторов
      </ui-button>
      <ui-textbox
        name="abo_number_search"
        label="Поиск по номеру НПА"
        :floatingLabel="true"
        v-model="aboNumberSearchQuery"
        width="400"
      ></ui-textbox>
      <div class="page-moderation-filter">
        <span class="page-moderation-small">По типу пользователя:</span>
        <ui-radio
          v-model="filter.user_type"
          @input="additionalFilter"
          trueValue="all"
          checked
          value="all"
        >
          Любые
        </ui-radio>
        <ui-radio
          v-model="filter.user_type"
          @input="additionalFilter"
          trueValue="vip"
          value="vip"
        >
          VIP
        </ui-radio>
        <ui-radio
          v-model="filter.user_type"
          @input="additionalFilter"
          trueValue="abo"
          value="abo"
        >
          НПА
        </ui-radio>
      </div>
      <div class="page-moderation-filter">
        <span class="page-moderation-small">По статусу страницы:</span>
        <ui-radio
          v-model="filter.enabled"
          @input="additionalFilter"
          trueValue="all"
          checked
          value="all"
          >Любые</ui-radio
        >
        <ui-radio
          v-model="filter.enabled"
          @input="additionalFilter"
          :trueValue="1"
          :value="1"
          >Включенные</ui-radio
        >
        <ui-radio
          v-model="filter.enabled"
          @input="additionalFilter"
          :trueValue="0"
          :value="0"
          >Выключенные</ui-radio
        >
        <ui-checkbox
          v-if="tab === 'changed'"
          v-model="filter.bChangedOnly"
          @input="additionalFilter"
          >Требует повторной модерации</ui-checkbox
        >
      </div>
    </div>
    <table class="page-moderation-body">
      <thead class="page-moderation-header">
        <tr>
          <th>Номер Amway</th>
          <th>Ссылки</th>
          <th>Тип пользователя</th>
          <th>Email</th>
          <th>Статус страницы</th>
          <th
            @click="callSort('last_modified')"
            class="sorted"
            :class="{
              'sorted-asc': sort.last_modified === 'ASC',
              'sorted-desc': sort.last_modified === 'DESC'
            }"
          >
            Последнее изменение
          </th>
          <th>Действия</th>
        </tr>
      </thead>
      <tbody class="page-moderation-body">
        <tr v-for="page in pages" :key="page.id">
          <td>
            {{ page.url }}
          </td>
          <td class="page-moderation-cell">
            <a
              target="_blank"
              :href="`https://www.kz.amway.com/users/${page.url}`"
              >Страница</a
            >
            |
            <a
              target="_blank"
              :href="`https://amwaypersonalpage.ru/preview/${page.url}`"
              >Превью страницы</a
            >
          </td>
          <td>
            {{ page.user_type.find(f => f.code === "abo") ? "НПА" : "" }}
            {{ page.user_type.find(f => f.code === "vip") ? "VIP" : "" }}
          </td>
          <td v-if="page.email">
            <a :href="`mailto:${page.email}`">
              {{ page.email }}
            </a>
          </td>
          <td v-else>
            Email не задан
          </td>
          <td :class="{ green: page.enabled, red: !page.enabled }">
            {{ page.enabled ? "Включена" : "Выключена" }}
            {{
              page.status === "b_changed"
                ? " (Требует повторной модерации)"
                : ""
            }}
          </td>
          <td>{{ page.last_modified }}</td>
          <td class="page-moderation-buttons">
            <ui-button
              v-if="
                ['new', 'changed', 'unviewed', 'b_changed'].includes(
                  page.status
                )
              "
              color="green"
              @click="setStatus(page, 'accepted')"
              size="small"
              >Принять
            </ui-button>
            <ui-button
              v-if="
                ['new', 'changed', 'unviewed', 'b_changed'].includes(
                  page.status
                )
              "
              color="red"
              @click="setStatus(page, 'declined')"
              size="small"
              >Отклонить
            </ui-button>
            <ui-button
              v-if="page.status === 'declined'"
              color="green"
              @click="setStatus(page, 'new')"
              size="small"
            >
              Вернуть
            </ui-button>
            <ui-button
              color="green"
              v-if="page.status === 'blocked'"
              @click="setStatus(page, 'new')"
              size="small"
            >
              Разблокировать
            </ui-button>
            <ui-button
              @click="openMessageModal(page.url)"
              color="accent"
              size="small"
            >
              Отправить сообщение
            </ui-button>
            <ui-button
              @click="loginAsUser(page.url)"
              color="primary"
              size="small"
              >Управлять страницей</ui-button
            >
            <ui-icon-button
              has-dropdown
              icon="more_vert"
              dropdownPosition="left middle"
            >
              <div
                class="moder-dropdown-menu"
                slot="dropdown"
                v-if="page.status !== 'blocked'"
              >
                <ui-button color="red" @click="setStatus(page, 'blocked')"
                  >Заблокировать
                </ui-button>
              </div>
            </ui-icon-button>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="page-moderation-buttons">
      <ui-button v-if="more" @click="loadMore">
        Загрузить ещё
      </ui-button>
    </div>
    <ui-modal ref="messageModal" dismiss-on="close-button esc">
      <h2 slot="header">Сообщение пользователю</h2>
      <div>
        <ui-textbox
          v-model="moderatorMessages.message"
          :multiLine="true"
          :rows="3"
          placeholder="Сообщение пользователю…"
        ></ui-textbox>
        <ui-button color="green" @click="sendMessage">Отправить</ui-button>
        <ui-button @click="$refs.messageModal.close()">Отменить</ui-button>
      </div>
    </ui-modal>
  </div>
  <form v-else class="page page-moderation-auth" @submit.prevent="auth">
    <ui-textbox
      name="password"
      v-model="authData.login"
      type="login"
      placeholder="Введите логин"
    ></ui-textbox>
    <ui-textbox
      name="password"
      v-model="authData.password"
      type="password"
      placeholder="Введите пароль"
    ></ui-textbox>
    <ui-button color="primary">Вход</ui-button>
  </form>
</template>

<script>
import { mapActions, mapState } from "vuex";
import moment from "moment";

require("moment/locale/ru");
moment.locale("ru");

export default {
  name: "Moderation",
  data() {
    return {
      apiRoot: process.env.VUE_APP_API_ROOT,
      tab: "new",
      loading: false,
      authData: {
        username: "",
        password: ""
      },
      moderatorMessages: {
        options: [
          {
            value: "fake_photo",
            label: "Фейковое фото или плохое качество"
          },
          {
            value: "wrong_about",
            label: "Неверная информация “О себе”"
          },
          {
            value: "wrong_name",
            label: "Неверные поля имя или фамилия"
          },
          {
            value: "wrong_info",
            label: "Неверная контактная информация"
          },
          {
            value: "wrong_certs",
            label: "Ошибка в “Мои сертификаты”"
          },
          {
            value: "wrong_networks",
            label: "Ошибка в “Социальные сети”"
          },
          {
            value: "other",
            label: "Другое"
          }
        ],
        type: "",
        abo_number: null,
        message: ""
      },
      sort: {
        last_modified: "DESC"
      },
      more: true,
      limit: 15,
      offset: 0,
      filter: {
        status: "new",
        enabled: "all",
        bChangedOnly: false,
        offset: 0,
        limit: 15,
        user_type: "all",
        order_by: "-last_modified"
      },
      moderationStat: null,
      pages: [],
      visiblePages: [],
      aboNumberSearchQuery: "",
      queryTimeout: null
    };
  },
  computed: mapState(["moderator"]),
  watch: {
    tab(newTab) {
      this.filter.status = newTab;
      if (newTab !== "changed") {
        this.filter.bChangedOnly = false;
      }
      this.update();
    },
    aboNumberSearchQuery(query) {
      if (this.queryTimeout) clearTimeout(this.queryTimeout);
      if (query) {
        this.queryTimeout = setTimeout(() => {
          let filter = {
            url__contains: query.trim(),
            status: this.filter.status,
            limit: 50
          };
          fetch(
            `${
              process.env.VUE_APP_API_ROOT
            }/api/moderation/get?${new URLSearchParams(filter).toString()}`,
            {
              method: "GET",
              credentials: "include"
            }
          )
            .then(r => r.json())
            .then(r => {
              this.pages = r.result;
              // this.more = false;
            });
        }, 300);
      } else {
        this.filter.offset = 0;
        this.update();
      }
    }
  },
  created() {},
  methods: {
    ...mapActions(["logoutAction"]),
    additionalFilter() {
      if (this.loading) return;
      this.filter.offset = 0;
      this.update();
    },
    preparePages(pages) {
      return pages.map(page => {
        page.last_modified = new Date(page.last_modified);
        page.last_modified_str = moment(page.last_modified).format(
          "DD.MM.YYYY HH:mm:ss"
        );
        return page;
      });
    },
    changeTab(id) {
      this.tab = id;
    },
    update(fullUpdate = false) {
      this.loading = true;
      const baseUrl = `${process.env.VUE_APP_API_ROOT}/api/moderation/get`;
      let filterCopy = Object.assign({}, this.filter);
      if (filterCopy.enabled === "all") {
        delete filterCopy.enabled;
      } else {
        filterCopy.enabled = Boolean(filterCopy.enabled);
      }

      if (filterCopy.bChangedOnly) {
        filterCopy.status = "b_changed";
      }
      delete filterCopy.bChangedOnly;
      if (fullUpdate) {
        filterCopy.limit = filterCopy.limit + filterCopy.offset;
        filterCopy.offset = 0;
      }
      let url;
      if (this.filter.status === "all") {
        delete filterCopy.status;
      }
      url = `${baseUrl}?${new URLSearchParams(filterCopy)}`;
      fetch(url, {
        method: "GET",
        credentials: "include"
      })
        .then(r => r.json())
        .then(response => {
          this.more = response.more;
          if (response.result) {
            let pages = response.result;
            if (this.filter.offset === 0) {
              this.pages = pages;
            } else {
              this.pages = [...this.pages, ...pages];
            }
          } else {
            this.pages = [];
          }
          this.loading = false;
        });
    },
    setStatus(page, status) {
      const url = `${process.env.VUE_APP_API_ROOT}/api/moderation/set_status/${status}`;
      const body = new FormData();
      if (status === "blocked" && !confirm("Вы уверены?")) return;
      body.append("page_id", page.id);
      return fetch(url, {
        method: "POST",
        credentials: "include",
        body: body,
        headers: {}
      })
        .then(r => r.json())
        .then(response => {
          if (response.status === "ok") {
            if (response.status === "declined") {
              this.openMessageModal(page.url);
            }
            this.moderator.stats[this.tab] -= 1;
            this.moderator.stats[status] += 1;
            this.update();
          }
        });
    },
    loadMore() {
      this.filter.offset += this.filter.limit;
      this.update();
    },
    callSort(key) {
      this.sort[key] = this.sort[key] === "ASC" ? "DESC" : "ASC";
      this.filter.order_by = `${this.sort[key] === "DESC" ? "-" : ""}${key}`;
      this.update(true);
    },
    auth() {
      const fd = new FormData();
      fd.append("username", this.authData.login);
      fd.append("password", this.authData.password);
      return fetch(`${process.env.VUE_APP_API_ROOT}/api/moderation/auth`, {
        method: "POST",
        body: fd,
        credentials: "include",
        headers: {}
      })
        .then(r => r.json())
        .then(resp => {
          if (resp.status === "ok") {
            this.update();
            this.$store.commit(
              "setModerator",
              Object.assign(resp.moderator, { stats: resp.moderator_stats })
            );
          } else {
            alert("Неверный пароль");
            throw "Неверный пароль";
          }
        })
        .catch(e => {
          console.error(e);
        });
    },
    loginAsUser(aboNumber) {
      const url = `${process.env.VUE_APP_API_ROOT}/api/moderation/auth_as_user/${aboNumber}`;
      fetch(url, {
        method: "POST",
        credentials: "include",
        headers: {}
      })
        .then(r => r.json())
        .then(r => {
          this.$store.commit("setUser", r.result.abo);
          this.$store.commit("setPage", r.result.page);
          window.open(`${window.location.origin}/`);
        });
    },
    openMessageModal(aboNumber) {
      this.moderatorMessages.abo_number = aboNumber;
      this.$refs.messageModal.open();
    },
    sendMessage() {
      const body = new FormData();
      if (!this.moderatorMessages.message) {
        return this.$eventBus.$emit("showError", {
          error: "Необходимо ввести текст сообщения."
        });
      }
      body.append("message", this.moderatorMessages.message);
      body.append("abo_number", this.moderatorMessages.abo_number);
      return fetch(
        `${process.env.VUE_APP_API_ROOT}/api/moderation/send_message`,
        {
          method: "POST",
          credentials: "include",
          headers: {},
          body: body
        }
      )
        .then(r => r.json())
        .then(r => {
          if (r.status === "error") {
            return this.$eventBus.$emit("showError", { error: r.message });
          } else {
            this.$refs.messageModal.close();
            this.moderatorMessages.type = "";
            this.moderatorMessages.message = "";
            this.moderatorMessages.abo_number = null;
            return this.$eventBus.$emit("serverSyncSuccess", {
              msg: "Сообщение успешно отправлено"
            });
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.page-moderation {
  padding: 0 5% 5%;

  &-buttons {
    padding-top: 20px;
  }

  &-auth {
    padding: 100px 0;
    max-width: 400px;
    margin: 0 auto;
  }

  &-body {
    & > * {
      transition: all 0.1s ease;
      opacity: 1;
    }

    &.loading {
      & > * {
        opacity: 0;
      }
    }
  }

  &-header {
    position: relative;

    th {
      text-align: left;
      padding: 10px 30px 10px 0;

      &.sorted {
        cursor: pointer;
        position: relative;

        &:before {
          content: "▲";
          position: absolute;
          left: -20px;
          top: 7px;
          transition: transform 0.2s ease-in-out;
        }

        &-desc:before {
          transform: rotate(180deg);
        }
      }
    }
  }

  &-body {
    tr {
    }
    td {
      padding: 10px 30px 10px 0;
      .red {
        color: red;
      }

      .green {
        color: green;
      }
    }
  }

  &-buttons {
    display: flex;
    flex-wrap: wrap;
    & > *:not(.ui-icon-button) {
      width: 100px;
    }
  }

  .logoutButton {
    position: absolute;
    right: 0;
    z-index: 1;
  }
  &-filter {
    & * {
      margin-bottom: 10px;
    }
  }
  &-small {
    display: inline-block;
    font-size: 12px;
    margin-bottom: 5px;
  }
}

.moder-dropdown-menu {
  display: flex;
  flex-direction: column;
  padding: 5px;
  background: #ffffff;
}
</style>
